import { Dialog, TextField } from "@mui/material";
import { useState } from "react";

import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import { defValueCaixaBancoHist, TCaixaBancoHistorico } from "../../types/api/financeiro/caixa-bancos-historico";

export default function SelectHistoricoCaixaBancos({
    value,
    required = false,
    error = false,
    errorMessage = undefined,
    onChange,
    disabled = false
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    const inputLabel = value ? `${value.id ?? ''}${value.id && value.descricao ? ' - ' : ''}${value.descricao ?? ''}` : ""

    return (
        <>
            <TextField
                {...{ required, error, disabled }}
                label={`Histórico padrão`}
                variant="outlined"
                fullWidth
                onClick={() => setOpenModal(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: { readOnly: true }
                }}
                value={inputLabel}
                helperText={error ? errorMessage : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose }}
                        title="Selecionar histórico"
                        queryPath="/financeiro/caixa-bancos/pesquisar-historicos"
                        getItemKey={(item) => item.id}
                        getItemLabel={(item) => `${item.id} - ${item.descricao}`}
                        defaultValue={value || defValueCaixaBancoHist}
                        onChange={(value) => {
                            onChange(value as TCaixaBancoHistorico)
                            handleClose()
                        }}
                    />
                </Dialog>

            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: TCaixaBancoHistorico
    onChange: (arg: TCaixaBancoHistorico | null) => void
    required?: boolean
    error?: boolean
    errorMessage?: string | undefined
    disabled?: boolean
}